
<template>
    <div class="d-flex flex-column flex" style="height: 100%">
        <div style="height: 100%">
            <v-card elevation="0" style="height: 100%">
                <v-card-title>Data-Correction</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="d-flex flex-column flex-md-row" >
                   <div class="flex-grow-1">
                        <v-tabs v-model="tab" class="flex-grow-1" outlined show-arrows>
                            <v-tab key="current">Current</v-tab>
                            <v-tab key="history">History</v-tab>
                                <v-tabs-items v-model="tab" class="">
                                    <v-tab-item key="current">
                                        <v-divider></v-divider>
                                        <current-change></current-change>
                                    </v-tab-item>
                                    <v-tab-item key="history">
                                        <v-divider></v-divider>
                                        <histotry-change></histotry-change>
                                    </v-tab-item>
                                </v-tabs-items>
                        </v-tabs>
                   </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>





<script>
import CurrentChange from "../../../components/Data-Corretion/CurrentChange.vue";
import HistotryChange from "../../../components/Data-Corretion/HistoryChange.vue";
export default {
    name: "DataCorrection",
    components: {
        CurrentChange,
        HistotryChange,
    },
    data: () => ({
        tab: null,

    })
}

</script>


